<ds-modal
  #uploadQueueFileModal
  [ds-modal-trigger-for]="uploadQueueFileModal"
  [isModalOpen]="modalIsOpen()"
  [dimensionsConfig]="{ width: '600px' }"
  [isDismissable]="true"
  (isModalOpenChange)="modalIsOpen.set($event)"
  (modalDismiss)="modalDismissed()"
>
  <ds-box-header>{{ 'backoffice.uploadQueueFileModal.title' | translate }}</ds-box-header>

  <ds-box-content class="content">
    <div class="d-flex">
      <div class="w-100 me-2x">
        <div class="d-flex align-items-center mb-1x">
          <ds-icon class="me-1x" icon="asterisk" size="sm" tone="critical" />
          <label ds-label class="text-regular" for="file-select">
            {{ 'backoffice.uploadQueueFileModal.selectFile' | translate }}
          </label>
        </div>

        <ds-form-field>
          <input
            #queueuploader
            ds-input
            hidden
            required
            size="lg"
            type="file"
            accept=".json"
            [formControl]="fileName"
            (change)="updateSelectedFile($event)"
          />
        </ds-form-field>

        <div class="d-flex align-items-center mb-1x mt-2x">
          <ds-icon class="me-1x" icon="asterisk" size="sm" tone="critical" />
          <label ds-label class="text-regular" for="interface-select">
            {{ 'backoffice.uploadQueueFileModal.selectInterface' | translate }}
          </label>
        </div>

        <ds-form-field>
          <ds-select
            id="interface-select"
            required
            size="lg"
            [isFilterable]="false"
            [labellingConfig]="{
              placeholder: 'backoffice.uploadQueueFileModal.filePlaceholder' | translate,
            }"
            [(ngModel)]="selectedQueue"
            [options]="interfaceOptions()"
          />
        </ds-form-field>

        @if (isComfyQueue()) {
          <div class="d-flex align-items-center mb-1x mt-2x">
            <ds-icon class="me-1x" icon="asterisk" size="sm" tone="critical" />
            <label ds-label class="text-regular" for="interface-select">
              {{ 'backoffice.uploadQueueFileModal.agent' | translate }}
            </label>
          </div>

          <ds-form-field>
            <ds-select
              id="interface-select"
              required
              size="lg"
              [isFilterable]="false"
              [labellingConfig]="{
                placeholder: 'backoffice.uploadQueueFileModal.agentPlaceholder' | translate,
              }"
              [(ngModel)]="selectedAgent"
              [options]="agentOptions()"
            />
          </ds-form-field>

          @if (selectedAgent() === comfyAgents.TRAMO) {
            <div class="d-flex align-items-center mb-1x mt-2x">
              <ds-icon class="me-1x" icon="asterisk" size="sm" tone="critical" />
              <label ds-label class="text-regular" for="interface-select">
                {{ 'backoffice.uploadQueueFileModal.action' | translate }}
              </label>
            </div>

            <ds-form-field>
              <ds-select
                id="interface-select"
                required
                size="lg"
                [isFilterable]="false"
                [labellingConfig]="{
                  placeholder: 'backoffice.uploadQueueFileModal.actionPlaceholder' | translate,
                }"
                [(ngModel)]="selectedAction"
                [options]="tramoActionsOptions()"
              />
            </ds-form-field>
          }
        }
      </div>
    </div>
  </ds-box-content>

  <ds-box-footer>
    <button class="me-2x" ds-button id="btn-cancel-modal" variant="outline" #dsModalDismissElement>
      {{ 'common.buttons.cancel' | translate }}
    </button>
    <button ds-button icon="add" variant="primary" (click)="uploadQueueFile()" [disabled]="disableSave()">
      {{ 'backoffice.uploadQueueFileModal.addFile' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
